
import React, { useState, useEffect } from "react";
import FacebookLogin from 'react-facebook-login';
// reactstrap components
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  Container,
  Col,
  Input,
  InputGroup,
  InputGroupAddon,
  InputGroupText,
  Button,
} from "reactstrap";
import useGlobal from "store";


// core components
import nowLogo from "assets/brand/logonew_white.png";

import bgImage from "assets/img/bg-city.jpg";
import { Link, Redirect } from "react-router-dom";

const LoginPage = (props) => {

  const [redirectRoute, setRedirectRoute] = useState(false);
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [passwordResetSent, setPasswordResetSent] = useState(false);

  const [state, actions] = useGlobal(
    state => state,
    actions => actions
  );

  useEffect(() => {
    console.log('state auth', state.auth);
    if(state.auth) {
      actions.userActions.getUserMe();
      setRedirectRoute('/admin/dashboard');
    }
  }, [state.auth, actions.userActions]);


  const [formState, setFormState] = useState({
    email: '',
    password: ''
  });

  const handleInputChange = (event) => {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    let formFields = { ...formState };
    formFields[name] = value;
    setFormState(formFields);
}

  const submitForm = async (event) => {
    console.log('submit form');
    event.preventDefault();
    const justFormData = new FormData(event.target);
    var object = {};
    justFormData.forEach((value, key) => {object[key] = value});
    const formData = { ...formState };
    console.log('FORM DATA', formData);


    actions.authActions.getAuthToken(formData);
  }

  const submitResetPasswordForm = async (event) => {
    console.log('submit reset password form');
    event.preventDefault();
    actions.authActions.resetPassword({
      email: formState.email
    });
    setPasswordResetSent(true);
  }

  const forgotPassword = (e) => {
    setShowForgotPassword(true);
  }
  const resetLogin = () => {
    setShowForgotPassword(false);
    setPasswordResetSent(false);
  }

  const responseFacebook = (response) => {
    console.log('FACEBOOK LOGIN response', response);
    if(!response.accessToken) {
      return;
    }
    actions.authActions.getFbAuthToken(response);
  }

  return (redirectRoute ?  <Redirect to={redirectRoute} /> 
      : <>
        <div className="content">
          <div className="login-page">
            <Container>
              <Col xs={12} md={8} lg={4} className="ml-auto mr-auto">
              { showForgotPassword ?
                <Form onSubmit={submitResetPasswordForm}>
                    <Card className="card-login card-plain">
                    <CardHeader>
                      <div className="logo-container">
                        <img src={nowLogo} alt="now-logo" />
                      </div>
                    </CardHeader>
                    { passwordResetSent ?
                      <CardBody>
                        <p className="text-white">Check your email. We sent you a link to reset your password.</p>
                        <Button
                          block
                          color="primary"
                          size="lg"
                          type="button"
                          className="mb-3 mt-3 btn-round"
                          onClick={() => resetLogin()}
                        >
                          OK
                        </Button>
                      </CardBody> :
                      <CardBody>
                        <InputGroup
                          className={
                            "form-control-lg "
                          }
                        >
                          <InputGroupAddon addonType="prepend">
                            <InputGroupText>
                              <i className="now-ui-icons users_circle-08" />
                            </InputGroupText>
                          </InputGroupAddon>
                          <Input
                            type="text"
                            placeholder="Email..."
                            value={formState.email || ''} onChange={handleInputChange} name="email"
                          />
                        </InputGroup>
                        
                        <Button
                          block
                          color="primary"
                          size="lg"
                          type="submit"
                          className="mb-3 mt-3 btn-round"
                        >
                          Reset Password
                        </Button>
                      </CardBody> }
                    </Card>
                </Form>
                : <Form onSubmit={submitForm}>
                  <Card className="card-login card-plain">
                    <CardHeader>
                      <div className="logo-container">
                        <img src={nowLogo} alt="now-logo" />
                      </div>
                    </CardHeader>
                    <CardBody>
                      <InputGroup
                        className={
                          "no-border form-control-lg "
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons users_circle-08" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="text"
                          placeholder="Email..."
                          value={formState.email || ''} onChange={handleInputChange} name="email" id="email"
                        />
                      </InputGroup>
                      <InputGroup
                        className={
                          "no-border form-control-lg "
                        }
                      >
                        <InputGroupAddon addonType="prepend">
                          <InputGroupText>
                            <i className="now-ui-icons objects_key-25" />
                          </InputGroupText>
                        </InputGroupAddon>
                        <Input
                          type="password"
                          placeholder="Password..."
                          value={formState.password || ''} onChange={handleInputChange} name="password" id="password"
                        />
                      </InputGroup>
                      <Button
                        block
                        color="primary"
                        size="lg"
                        type="submit"
                        className="mb-3 mt-3 btn-round"
                      >
                        Login
                      </Button>
                      <FacebookLogin
                        appId="388953482500407"
                        autoLoad={false}
                        fields="name,email,picture"
                        cssClass="btn btn-block btn-facebook"
                        callback={responseFacebook} />
                    </CardBody>
                    <CardFooter>
                      
                      <div className="text-center">
                        <h6>
                          <Link to="/auth/signup" className="link footer-link">
                            Create Account
                          </Link>
                        </h6>
                      </div>
                      <div className="text-center mt-3">
                        <h6>
                          <span onClick={()=>forgotPassword()} style={{cursor:"pointer"}} className="link footer-link">Forgot your password?</span>
                        </h6>
                      </div>
                      
                    </CardFooter>
                  </Card>
                </Form> }
              </Col>
            </Container>
          </div>
        </div>
        <div
          className="full-page-background"
          style={{ backgroundImage: "url(" + bgImage + ")" }}
        />
      </>
    );
}

export default LoginPage;
